<template lang="pug">
div
  Account(v-if="$route.query.account_id")
  template(v-else)
    UiCardSection
      UiStack
        UiStackItem(fill)
          .ui-card-section-title {{ $t("companies.tabs.account_list") }}
        UiStackItem
          UiButton(
            variant="primary"
            @click="addAccountKeyword"
            icon="Plus"
          ) {{ $t("actions.add") }}
    UiCardSection
      RestTable(
        namespace="accounts"
        :embed="true"
        :headers="headers"
        :items="items"
        ref="companyAccountListTable"
        :fetch-handler="getData"
        :initial-filters="initialFilters"
      )
        template(#filters="{ filters, updateFilters }")
          UiStack(align="end")
            UiStackItem
              UiFileInput(
                v-model="matchFile"
                :success="!!matchFile"
                placeholder="Choose a file..."
                :extensions="['csv']"
              )
            UiStackItem
              UiButton(
                variant="primary"
                @click="downloadMatchFile"
                icon="FileDownload"
              ) {{ $t("actions.download") }}
            UiStackItem
              UiButton(
                :disabled="!Boolean(matchFile)"
                variant="primary"
                @click="uploadMatchFile"
                icon="FileUpload"
              ) {{ $t("actions.upload") }}
            UiStackItem
              UiStack(spacing="xs")
                UiInputLabel(:shifted="false") {{ $t("companies.account_keyword.number") }}
                UiInput#netvisor-key-input(
                  :modelValue="filters.search"
                  type="search"
                  @update:modelValue="updateFilters({ search: $event })"
                  inputSize="20"
                )
            UiStackItem
              UiStack(spacing="xs")
                UiInputLabel(:shifted="false") {{ $t("companies.account_keyword.keywords") }}
                UiInput#keyword-input(
                  :modelValue="filters.search_keyword"
                  type="search"
                  @update:modelValue="updateFilters({ search_keyword: $event })"
                  inputSize="30"
                )
        template(#cell:keywords="{ item }")
          UiTagsInput(
            v-if="item.is_keyword"
            size="sm"
            v-model="item.keywords"
            :placeholder="$t('companies.dimensions.keywords_prompt')"
            @update:modelValue="changeKeywords(item)"
          )
          UiTagsInput(
            v-if="!item.is_keyword"
            size="sm"
            v-model="item.keywords"
            :placeholder="$t('companies.dimensions.keywords_prompt')"
            @update:modelValue="createKeywords(item)"
          )
        template(#cell:actions="{ item }")
          UiStack(
            spacing="xs"
            v-if="item.is_keyword"
          )
            UiStackItem
              UiButton(
                size="sm"
                variant="smooth-danger"
                @click="deleteAccountKeyword(item)"
                icon="Trash"
              ) {{ $t("actions.delete") }}
            UiStackItem(v-if="item.is_active && item.is_keyword")
              UiButton(
                size="sm"
                variant="smooth-danger"
                @click="deactivate(item)"
                icon="Close"
              ) {{ $t("actions.deactivate") }}
            UiStackItem(v-if="!item.is_active && item.is_keyword")
              UiButton(
                size="sm"
                variant="smooth-primary"
                @click="activate(item)"
                icon="Check"
              ) {{ $t("actions.activate") }}
        template(#cell:is_active="{ item }")
          UiButton(
            size="sm"
            :variant="STATUSES[item.is_active] || 'info'"
            :icon="item.is_active ? 'Check' : 'Close'"
          ) {{ item.is_active }}
        template(#cell:in_accountlist="{ item }")
          UiButton(
            size="sm"
            :variant="STATUSES[item.in_accountlist] || 'info'"
            :icon="item.in_accountlist ? 'Check' : 'Close'"
          ) {{ item.in_accountlist }}
        template(#cell:dont_suggest_account="{ item }")
          UiCheckbox(
            v-if="item.in_accountlist"
            v-model="item.dont_suggest_account"
            switch
            @update:modelValue="changeDontSuggestAccount(item)"
          )
        template(#cell:approver_id="{ item }")
          RouterLink(
            :to="{ ...$route, query: { ...$route.query, account_id: item.number } }"
            label="item.name"
          ) Approvers
    ReplacementAccountList
    CreateAccountKeywordModal(
      ref="CreateAccountKeywordModal"
      @done="reloadList"
    )
</template>

<script>
import router from "@/router";
import ApiCompanyAccountKeyword from "@/api/companyAccountKeyword.js";
import CreateAccountKeywordModal from "@/modals/Companies/createAccountKeyword.vue";
import ApiCompanyFeatures from "@/api/companyFeatures.js";
import ReplacementAccountList from "../replacementAccountList.vue";
import Account from "@/views/Accounts/index.vue";
import ApiCompanyAccount from "@/api/companyAccount.js";

const STATUSES = {
  true: "success",
  false: "danger",
};

export default {
  components: {
    CreateAccountKeywordModal,
    ReplacementAccountList,
    Account,
  },

  data() {
    return {
      matchFile: null,
      STATUSES: STATUSES,
      initialFilters: {
        sort_order: "desc",
      },
      headers: [
        {
          key: "number",
          label: "Number",
          squeeze: true,
        },
        {
          key: "keywords",
          label: "Keywords",
          squeeze: false,
          sortable: true,
        },
        {
          key: "is_active",
          label: "Active",
          squeeze: false,
        },
        {
          key: "in_accountlist",
          label: "In account list",
          squeeze: false,
        },
        {
          key: "dont_suggest_account",
          label: "Don't suggest account",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
        {
          key: "approver_id",
          label: "Approver",
          squeeze: false,
        },
      ],
      items: [],
      approvers: [],
    };
  },

  methods: {
    reloadList() {
      this.$refs.companyAccountListTable.fetchData();
    },
    getData(params, config) {
      return ApiCompanyAccountKeyword.fetchFullAccountList(
        this.$route.params.id,
        params,
        config,
      )
        .then((resp) => {
          this.items = resp.data.accounts;
          return {
            items: resp.data.accounts,
            meta: resp.data.meta,
          };
        })
        .catch((e) => {});
    },
    goBack() {
      router.push("/companies");
    },
    changeKeywords(item) {
      this.saveAccountKeyword(item.id, {
        account_keyword: { keywords: item.keywords },
      });
    },
    changeDontSuggestAccount(item) {
      ApiCompanyAccount.updateDontSuggestAccount(this.$route.params.id, {
        company_account: { number: item.number, dont_suggest_account: item.dont_suggest_account },
      }).then((resp) => {
        this.reloadList();
      });
    },
    createKeywords(item) {
      this.createAccountKeyword(item.id, {
        account_keyword: { keywords: item.keywords, number: item.number },
      });
    },
    createAccountKeyword(id, params) {
      ApiCompanyAccountKeyword.createAccountKeyword(
        this.$route.params.id,
        params,
      ).then((resp) => {
        this.reloadList();
      });
    },
    saveAccountKeyword(id, params) {
      ApiCompanyAccountKeyword.updateAccountKeyword(
        this.$route.params.id,
        id,
        params,
      ).then((resp) => {
        this.reloadList();
      });
    },
    activate(item) {
      this.saveAccountKeyword(item.id, { is_active: "true" });
    },
    deactivate(item) {
      this.saveAccountKeyword(item.id, { is_active: "false" });
    },
    deleteAccountKeyword(item) {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("actions.confirm_remove"),
        variant: "danger",
        icon: "lan-disconnect",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiCompanyAccountKeyword.deleteAccountKeyword(
          this.$route.params.id,
          item.id,
        ).then((resp) => {
          this.reloadList();
        });
      });
    },
    addAccountKeyword() {
      this.$refs.CreateAccountKeywordModal.open(this.$route.params.id, null);
    },

    editAccountKeyword(item) {
      this.$refs.CreateAccountKeywordModal.open(this.$route.params.id, item);
    },
    uploadMatchFile() {
      let formData = new FormData();
      formData.append("file", this.matchFile);
      ApiCompanyFeatures.uploadMatchFile(this.$route.params.id, formData)
        .then((resp) => {
          this.$emit("done");
          this.close();
        })
        .catch((e) => {
          this.$toaster.add({
            type: "error",
            title: this.$t("errors.operation_error"),
            message: "Can't upload match file",
          });
        });
    },
    downloadMatchFile() {
      ApiCompanyFeatures.downloadMatchFile(this.$route.params.id)
        .then((resp) => {
          let fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "file.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((e) => {});
    },
  },
};
</script>
